import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import PageHeading from "../components/pageheading";
import CallToAction from "../components/cta";
import "../styles/global.scss";

export default function Services({ data }) {
  return (
    <Layout>
      <div className="services">
        <PageHeading heading="Our Services" />

        <div className="block">
          <div className="text-l">
            <h4>National same-day courier services</h4>
            <p>
              Haslam Logistics is one of the most trusted names when it comes to
              same-day deliveries and time critical deliveries. Fast UK delivery
              is available throughout the UK which we achieve through our 60
              minute pick up times due to our vehicles being strategically
              placed throughout the country. From small documents to full lorry
              loads we’ve got it covered. We can provide tracking for all of our
              services with out GPS enabled vehicles. With numerous 5 star
              reviews on Google, We’re proud to present a courier service that
              can meet the toughest of demands available to you 24 / 7 / 365.
            </p>
          </div>
          <div className="spacer"></div>
          <div className="img-r">
            <Img
              fluid={data.smilingCourier.childImageSharp.fluid}
              alt="Courier checking parcels"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-l">
            <h4>B2B courier services</h4>
            <p>
              Business to business fast courier services are available and can
              be easily requested through our friendly and professional
              operations team. You simply tell us the what, where and When, and
              we’ll get it done. Rapid B2B delivery is what we believe keeps the
              nation running and we’re happy to say we’re a big part of that.
              Temperature controlled deliveries, and Large loads are available
              and are no problem. Businesses can have custom requirements and
              we’re pleased to tell you that our operations team is experienced
              in provide bespoke and custom delivery solutions. Get in touch
              today, to see how we can help.
            </p>
          </div>
          <div className="spacer"></div>

          <div className="img-r">
            <Img
              fluid={data.vehicleRange.childImageSharp.fluid}
              alt="range of courier vehicles"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-r">
            <h4>Two man teams and white glove services </h4>
            <p>
              Many customers require more than one person to handle the freight
              or consignment. We’re able to complete these task with ease with
              our two man teams available 24 / 7 / 365. Those items can be
              placed exactly where you need them to be with all packaging
              removed in a safeland environmentally conscious manner which we do
              to help reduce the carbon footprint Of our customers. This is
              called a white glove service, where our friendly staff can place
              your items where you need them to be.
            </p>
          </div>
          <div className="spacer"></div>

          <div className="img-l">
            <Img
              fluid={data.menCheckingBoxes.childImageSharp.fluid}
              alt="Couriers loading boxes"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-r">
            <h4>Wait and return services</h4>
            <p>
              If you need a service where you drop off goods and pick other
              goods up, why not speak to our advisers about our wait and return
              service? It’s a great way to save money on multiple trips, And a
              great way to help a little in saving the environment by lowering
              your carbon footprint in your deliveries.
            </p>
          </div>
          <div className="spacer"></div>

          <div className="img-l">
            <Img
              fluid={data.vanLoad.childImageSharp.fluid} 
              alt="Van being loaded with goods"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-l">
            <h4>Multi drop deliveries</h4>
            <p>
              Our dedicated teams will carry out multiple location drops for
              your goods, to ensure efficiency. Speak to our friendly advisers
              to find out more.
            </p>
          </div>
          <div className="spacer"></div>

          <div className="img-r">
            <Img
              fluid={data.vanCollection.childImageSharp.fluid}
              alt="multiple courier vans"
            />
          </div>
        </div>

        <div className="block">
          <div className="text-l">
            <h4>Storage Services</h4>
            <p>
              If you need some help with storage of your goods before you
              receive them, or before they arrive at your chosen destination.
              Speak to us so we can help you.
            </p>
          </div>
          <div className="spacer"></div>

          <div className="img-r">
            <Img
              fluid={data.warehouse_worker.childImageSharp.fluid}
              alt="Warehouse worker smiling"
            />
          </div>
        </div>
        <CallToAction to="/contact" text="Contact Us" />
        <div className="seo">
        <h5>Which areas do we cover?</h5>
        <p className='emphasise'>
          We provide fast, cheap and same-day delivery with excellent customer service to the {' '} 
          <strong>entire UK and Republic of Ireland</strong>. If you can name it, we've probably delivered there before! This includes, but is not limited to:
        </p>
        <p>Cities in England:</p>
        <p>
          Bath Birmingham Bradford Brighton and Hove Bristol Cambridge
          Canterbury Carlisle Chester Chichester Coventry Derby Durham Ely
          Exeter Gloucester Hereford Kingston upon Hull Lancaster Leeds
          Leicester Lichfield Lincoln Liverpool City of London Manchester
          Newcastle upon Tyne Norwich Nottingham Oxford Peterborough Plymouth
          Portsmouth Preston Ripon Salford Salisbury Sheffield Southampton St
          Albans Stoke-on-Trent Sunderland Truro Wakefield Wells Westminster
          Winchester Wolverhampton Worcester York
        </p>
        <p>Cities in Wales:</p>
        <p>Bangor Cardiff Newport St Davids Swansea</p>
        <p>Cities in Scotland:</p>
        <p>Aberdeen Dundee Edinburgh Glasgow Inverness Stirling</p>
        <p>Cities in Northern Ireland:</p>
        <p>Armagh Belfast Londonderry Lisburn Newry</p>
        <p></p>
        <p>Cities in Ireland:</p>
        <p>
          Dublin Cork Limerick Derry Galway Waterford Drogheda Dundalk Swords
          Bray Navan Kilkenny
        </p>
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query {
    smilingCourier: file(relativePath: { eq: "smiling courier.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    vehicleRange: file(relativePath: { eq: "same-day-couriers-service.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    menCheckingBoxes: file(relativePath: { eq: "Men checking boxes.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }


      vanLoad:  file(relativePath: {eq: "Van being loaded.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 800) {
             ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      
      
      

    vanCollection: file(relativePath: { eq: "Collection of vans.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    warehouse_worker: file(relativePath: {eq: "warehouse worker.jpg"}) {
          childImageSharp {
            fluid (maxWidth: 800) {
            ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
`;

